module.exports = __webpack_public_path__ + "images/07862c8e9d05fc89d38044fc4a6ec009.svg";